import { call, put, takeLatest } from "redux-saga/effects";
import { GET_PhaseList, POST_Phase, PUT_Phase, DELETE_Phase } from "../services/Phase";
import exception from "../utils/exception";
import { jwtDecode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_PhaseListEffect({ projectId, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_PhaseList, token, projectId);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_PhaseList", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_PhaseEffect({ projectId, formData, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    yield call(POST_Phase, token, projectId, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* PUT_PhaseEffect({ phaseId, formData, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    yield call(PUT_Phase, token, phaseId, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* DELETE_PhaseEffect({ phaseId, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    yield call(DELETE_Phase, token, phaseId);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* Example() {
  yield takeLatest("GET_PhaseList", GET_PhaseListEffect);
  yield takeLatest("POST_Phase", POST_PhaseEffect);
  yield takeLatest("PUT_Phase", PUT_PhaseEffect);
  yield takeLatest("DELETE_Phase", DELETE_PhaseEffect);
}
